import { useContext, useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ProductContext } from "../context/ProductContext";
import HomeMain from "../layouts/main/HomeMain";

import { Helmet } from "react-helmet-async";

const Container = styled.article`
  color: ${(props) => props.theme.textColor};
`;
const Section = styled.section`
  height: 100vh;
`;
const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
const Home = () => {
  const { t, i18n } = useTranslation();
  const { loadProducts } = useContext(ProductContext);

  useEffect(() => {
    loadProducts();
  }, [i18n.language]);

  const seoData = {
    en: {
      title: "Buy Nicotine Pouches Snus – Strong and Refreshing Flavors",
      description:
        "Discover the best nicotine pouches snus with intense flavors and various nicotine strengths. Order now for fast delivery and top quality!",
      keywords:
        "nicotine pouches, snus, buy nicotine pouches, strong snus, nicotine snus, fresh flavors, snus Austria",
      ogTitle: "Buy Nicotine Pouches Snus – Strong and Refreshing Flavors",
      ogDescription:
        "Buy the best nicotine pouches snus with intense flavors and various nicotine strengths. Fast delivery in Austria and Germany!",
      twitterTitle: "Buy Nicotine Pouches Snus – Strong and Refreshing Flavors",
      twitterDescription:
        "Discover strong and refreshing nicotine pouches snus. Order online in Austria and Germany. Fast delivery guaranteed!",
      url: "https://www.snusco.at/",
      image: "https://www.snusco.at/images/snuspouch.jpg",
      locale: "en",
    },
    de: {
      title: "Nikotinsäcke Snus kaufen – Starke und erfrischende Aromen",
      description:
        "Entdecken Sie die besten Nikotinsäcke Snus mit intensiven Aromen und verschiedenen Nikotinstärken. Bestellen Sie jetzt und genießen Sie schnelle Lieferung und Top-Qualität!",
      keywords:
        "Nikotinsäcke, Snus, Nikotinbeutel kaufen, starker Snus, Nikotinsnus, frische Aromen, Snus Deutschland",
      ogTitle: "Nikotinsäcke Snus kaufen – Starke und erfrischende Aromen",
      ogDescription:
        "Kaufen Sie die besten Nikotinsäcke Snus mit intensiven Aromen und verschiedenen Nikotinstärken. Schnelle Lieferung in Deutschland und Österreich!",
      twitterTitle: "Nikotinsäcke Snus kaufen – Starke und erfrischende Aromen",
      twitterDescription:
        "Entdecken Sie starke und erfrischende Nikotinsäcke Snus. Bestellen Sie online in Deutschland und Österreich. Schnelle Lieferung garantiert!",
      url: "https://www.snusco.at/",
      image: "https://www.snusco.at/images/snuspouch.jpg",
      locale: "de",
    },
  };

  const currentSeo = seoData[i18n.language] || seoData.en;

  return (
    <>
      <Helmet>
        {/* Meta Title */}
        <title>{currentSeo.title}</title>

        {/* Meta Description */}
        <meta name="description" content={currentSeo.description} />

        {/* Meta Keywords */}
        <meta name="keywords" content={currentSeo.keywords} />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content={currentSeo.ogTitle} />
        <meta property="og:description" content={currentSeo.ogDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={currentSeo.url} />
        <meta property="og:image" content={currentSeo.image} />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={currentSeo.twitterTitle} />
        <meta
          name="twitter:description"
          content={currentSeo.twitterDescription}
        />
        <meta name="twitter:image" content={currentSeo.image} />

        {/* Canonical Link */}
        <link rel="canonical" href={currentSeo.url} />

        {/* Additional Meta Tags */}
        <meta property="og:locale" content={currentSeo.locale} />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <HomeMain />
    </>
  );
};

export default Home;
